import { FastLaneWizardStep, FastLaneWizardState } from '../../models/fastlane-wizard-state';

export abstract class WizardPageContent {
	readonly stepIndex: FastLaneWizardStep;
	constructor(stepIndex: FastLaneWizardStep, state: FastLaneWizardState) {
		this.stepIndex = stepIndex;
		state.errorInPage = false;
	}
	abstract checkError(): boolean;
}
